import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navigation } from '../../navigation/react-redux-nav';
import Icon, { NAMES } from '@ifit/react-icons';
import classNames from 'classnames';
import { shark } from '../../theme/colors';

import './index.css';

export default class FloatingBar extends Component {
  constructor(props) {
    super(props);

    this.ticking = false;
    this.state = { isScrolling: false };
  }

  static propTypes = {
    showLoginButton: PropTypes.bool,
    backFunction: PropTypes.func,
    skipNavigation: PropTypes.bool,
    jumpFunction: PropTypes.func,
    appName: PropTypes.string
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollRequest);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollRequest);
  }

  handleScrollRequest= () => {
    if (this.ticking) return;
    requestAnimationFrame(() => {
      this.handleScroll();
      this.ticking = false;
    });
    this.ticking = true;
  }

  handleScroll = () => {
    if (window.pageYOffset > 0) {
      this.setState({ isScrolling: true });
    } else {
      this.setState({ isScrolling: false });
    }
  }

  render() {
    return (
      <div className={ classNames('floating-bar', { 'on-scroll': this.state.isScrolling }) }>
        <Navigation.Backward onClick={ this.props.backFunction } skipNavigation={ this.props.skipNavigation }>
          <Icon
            name={ NAMES.ARROW_LEFT }
            color={ shark }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>
        { this.props.showLoginButton &&
          <Navigation.JumpTo page="login" onClick={ this.props.jumpFunction } skipNavigation={ this.props.appName === 'wolf' }>
            <button className="login-button">Log in</button>
          </Navigation.JumpTo>
        }
      </div>
    );
  }
}
